import gql from "graphql-tag";

/**
 * Change the Port Status
 */

const ChangeShippingRequestPortStatus = gql`
	mutation(
		$shipping_request_id: String!
		$new_status: ShippingRequestPortStatus!
		$message: String
	) {
		ChangeShippingRequestPortStatus(
			shipping_request_id: $shipping_request_id
			new_status: $new_status
			message: $message
		) {
			id
			port_status
		}
	}
`;

export default ChangeShippingRequestPortStatus;
